module.exports = {
      id: "8860d2e1f1e1b27d4bd057f00397579cconstruction-timber.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#8860d2e1f1e1b27d4bd057f00397579cconstruction-timber.svg",
      toString: function () {
        return this.url;
      }
    }